import React, { cloneElement } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

const ScreenReaderOnly = ({ children }) => {
  const classes = cn('c-screen-reader-only', children.props.className);
  const props = {
    ...children.props,
    ...{
      className: classes,
    },
  };

  return cloneElement(children, props);
};

export default ScreenReaderOnly;

ScreenReaderOnly.propTypes = {
  children: PropTypes.node.isRequired,
};
